import {LetterPriceDto} from "./letter-price.dto";
import {MediaFileType} from "../../libs/enum/media-file-type.enum";

export class SendLetterDto extends LetterPriceDto {

  public type!: MediaFileType;
  public contactId!: string;
  public addressId!: string;
  public vehicleId: string | undefined;

  constructor(init?: Partial<SendLetterDto> | undefined) {
    super(init);
    Object.assign(this, init);
  }
}
